module.exports = __webpack_public_path__ + "static/media/IMG_20240228_141400 (1).fbbc70fa.jpg";